export var cities = {
  TW: {
    TPE: {
      label: '臺北市',
      i18n: 'common:taiwan_cities.taipei_city',
      value: 'TPE'
    },
    TXG: {
      label: '臺中市',
      i18n: 'common:taiwan_cities.taichung_city',
      value: 'TXG'
    },
    KEE: {
      label: '基隆市',
      i18n: 'common:taiwan_cities.keelung_city',
      value: 'KEE'
    },
    TNN: {
      label: '臺南市',
      i18n: 'common:taiwan_cities.tainan_city',
      value: 'TNN'
    },
    KHH: {
      label: '高雄市',
      i18n: 'common:taiwan_cities.kaohsiung_city',
      value: 'KHH'
    },
    NWT: {
      label: '新北市',
      i18n: 'common:taiwan_cities.new_taipei_city',
      value: 'NWT'
    },
    ILA: {
      label: '宜蘭縣',
      i18n: 'common:taiwan_cities.yilan_county',
      value: 'ILA'
    },
    TAO: {
      label: '桃園市',
      i18n: 'common:taiwan_cities.taoyuan_city',
      value: 'TAO'
    },
    CYI: {
      label: '嘉義市',
      i18n: 'common:taiwan_cities.chiayi_city',
      value: 'CYI'
    },
    HSQ: {
      label: '新竹縣',
      i18n: 'common:taiwan_cities.hsinchu_county',
      value: 'HSQ'
    },
    MIA: {
      label: '苗栗縣',
      i18n: 'common:taiwan_cities.miaoli_county',
      value: 'MIA'
    },
    NAN: {
      label: '南投縣',
      i18n: 'common:taiwan_cities.nantou_county',
      value: 'NAN'
    },
    CHA: {
      label: '彰化縣',
      i18n: 'common:taiwan_cities.changhua_county',
      value: 'CHA'
    },
    HSZ: {
      label: '新竹市',
      i18n: 'common:taiwan_cities.hsinchu_city',
      value: 'HSZ'
    },
    YUN: {
      label: '雲林縣',
      i18n: 'common:taiwan_cities.yunlin_county',
      value: 'YUN'
    },
    CYQ: {
      label: '嘉義縣',
      i18n: 'common:taiwan_cities.chiayi_county',
      value: 'CYQ'
    },
    PIF: {
      label: '屏東縣',
      i18n: 'common:taiwan_cities.pingtung_county',
      value: 'PIF'
    },
    HUA: {
      label: '花蓮縣',
      i18n: 'common:taiwan_cities.hualien_county',
      value: 'HUA'
    },
    TTT: {
      label: '臺東縣',
      i18n: 'common:taiwan_cities.taitung_county',
      value: 'TTT'
    },
    KIN: {
      label: '金門縣',
      i18n: 'common:taiwan_cities.kinmen_county',
      value: 'KIN'
    },
    PEN: {
      label: '澎湖縣',
      i18n: 'common:taiwan_cities.penghu_county',
      value: 'PEN'
    },
    LIE: {
      label: '連江縣',
      i18n: 'common:taiwan_cities.lienchiang_county',
      value: 'LIE'
    }
  }
};